import React from "react";
import compose from "ramda/src/compose";

import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Editor } from "../Editor";
import { Box } from "../../UI/Box";

export const PREVIEW_TOOLBAR = [
  ["bold", "italic", "underline", "strike", "link"], // toggled buttons

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript

  [{ size: ["10px", false, "20px", "40px"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ align: [] }],
];

interface IProps {
  textToEdit?: string;
  onSave: (text: string) => void;
}

export const UserNotificationEditModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const [text, setText] = React.useState("");

  const handleClose = () => setIsOpen(false);

  const handleSave = () => props.onSave(text);

  return (
    <Modal
      withoutTopBorder
      maxWidth="md"
      onClose={handleClose}
      title="Edit Confirmation Notification"
      actions={
        <>
          <Button appearance="subtle" onClick={handleClose}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={compose(handleClose, handleSave)}>
            Save
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Editor onChange={setText} defaultValue={props.textToEdit} previewToolbar={PREVIEW_TOOLBAR} />
      </Box>
    </Modal>
  );
};
